import * as crypto from 'crypto';

onmessage = (event) => {
    const scripts = event?.data?.scripts;
    var allScripts = scripts.map(s => s.name + ':' + s.text).join('--------------------------');
    var shasum = crypto.createHash('sha1');
    shasum.update(allScripts);
    postMessage(shasum.digest('hex'));
};